import config from 'constants/config'
import { LE_AGENT_HUB, LE_AGENT_HUB_CVFR } from 'constants/brands'
import useQueryParams from 'hooks/useQueryParams'

export default function useIsLoginV2Enabled(): boolean {
  const query = useQueryParams()

  switch (config.BRAND) {
    case LE_AGENT_HUB:
      return query.get('login-v1') !== 'true'
    case LE_AGENT_HUB_CVFR:
      return query.get('login-v2') === 'true'
    default:
      return false
  }
}
